import { Component } from '@angular/core';
import { OpenNativeSettings } from '@ionic-native/open-native-settings';
import { IonicPage, NavController, NavParams } from 'ionic-angular';


/**
 * Generated class for the ModalStorageRequestPermissionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-modal-storage-request-permission',
  templateUrl: 'modal-storage-request-permission.html',
})
export class ModalStorageRequestPermissionPage {

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private openNativeSettings: OpenNativeSettings
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ModalStorageRequestPermissionPage');
  }

  async openSetting() {
    await this.openNativeSettings.open('storage');
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/general/modal-storage-request-permission/modal-storage-request-permission.ts